var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 97,
    viewBox: "0 0 85 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9546 0.126221L83.5238 24.1262V72.1262L41.9546 96.1262L0.385372 72.1262V24.1262L41.9546 0.126221Z",
    fill: "#FAAC48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexActive);
export default __webpack_public_path__ + "static/media/hex-active.9beed671ef4929c0743c7cf52cd31b12.svg";
export { ForwardRef as ReactComponent };